export default __webpack_public_path__ + "static/media/ratcatcher-ii.639ee59a.png";